export default "__VITE_ASSET__BMj55s9p__"